import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css'; 
import '../scss/green-theme.css';
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import Mymodal from './modal';
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class LeaveManager extends Component{
    constructor(props)
    {
        super(props);
        this.state=
        { 
            input:{},
            myitems:[],
            leavedata:{},
            tLeave:0,
            isLoaded: true,
            isForm: "none",
            isData: false,
            EmpID:"",
            errorcss:"labelsave",
            errortext:"",
            apipath:"",
            ErrMsg:<img src={logo} alt=""/>
        }
        this.handleFocus = this.handleFocus.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    cur(num) 
    {
        if(typeof num === "undefined"){num=0;}
        //let cnum=parseInt(num, 0);
        if(num > 0)
            return Number(num).toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    componentDidMount(){
        this.setState({apipath:this.props.apipath});
    }
    handleInputChange = (e)=> {
      this.setState({EmpID: e.target.value});
    }
    handleFocus(event){event.target.select();}

    handleSubmit()
    {
        this.setState({errortext:"",errorcss:"labelerror"});
        if(this.state.EmpID.length < 6)
      {  
          this.setState({errortext:"Invalid employee id",errorcss:"labelerror"});
      }
      else
      {        
          document.body.style.cursor="wait";
          let input=this.state.input;
          input["ID"]=this.state.EmpID;
          this.setState({input, isLoaded: true});
          axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/leave/'+this.state.EmpID,
                url: this.state.apipath+'/index.php/user/leave/'+this.state.EmpID,
//                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                console.log(response.data);
                if(response.data.length == 0)
                {
                    this.setState({errortext:"Invalid employee id",errorcss:"labelerror"});
                    document.body.style.cursor="default";
                }
                else
                {
                document.body.style.cursor="default";
                let leavedata=this.state.leavedata;

                leavedata["Name"]=response.data[0].NAME;
                leavedata["Designation"]=response.data[0].DESIG;
                leavedata["Location"]=response.data[0].LOCATION;

                leavedata["BFAnnual"]=Number(response.data[0].BF_ANNUAL);
                leavedata["BFCasual"]=0; //response.data[0].BF_CASUAL;
                leavedata["BFSick"]=0; //response.data[0].BF_SICK;

                leavedata["Annual"]=Number(response.data[0].ANNUAL);
                leavedata["Casual"]=Number(response.data[0].CASUAL);
                leavedata["Sick"]=Number(response.data[0].SICK);

                leavedata["BAnnual"]=Number(response.data[0].ANNUAL)+Number(response.data[0].BF_ANNUAL);
                leavedata["BCasual"]=Number(response.data[0].CASUAL);
                leavedata["BSick"]=Number(response.data[0].SICK);

                leavedata["EAnnual"]=Number(response.data[0].E_ANNUAL);
                leavedata["ECasual"]=Number(response.data[0].E_CASUAL);
                leavedata["ESick"]= Number(response.data[0].E_SICK);

                leavedata["LAnnual"]=Number(response.data[0].L_ANNUAL);
                leavedata["LCasual"]=Number(response.data[0].L_CASUAL);
                leavedata["LSick"]=Number(response.data[0].L_SICK);
                this.setState({tLeave:leavedata["LAnnual"]+leavedata["LCasual"]+leavedata["LSick"]});

                leavedata["TAnnual"]=Number(response.data[0].BF_ANNUAL)+Number(response.data[0].ANNUAL)-Number(response.data[0].E_ANNUAL)-Number(response.data[0].L_ANNUAL);
                leavedata["TCasual"]=Number(response.data[0].CASUAL)-Number(response.data[0].E_CASUAL)-Number(response.data[0].L_CASUAL);
                leavedata["TSick"]=Number(response.data[0].SICK)-Number(response.data[0].E_SICK)-Number(response.data[0].L_SICK);

                this.setState({leavedata,isLoaded: true,isForm:"block", myitems: response.data,tLeave:1});
                }
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
      }
    }
    render()
    {
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      let isForm = this.state.isForm;
      if(isLoaded)
      {
        return( 
/*}                <div className="container1">
                <div style={{height:"75px",textAlign:"center",paddingTop:"5px"}}><h4>Leave Management </h4></div>
        */
        <div>
            <br></br>
                <table className="csstable" >
                <thead></thead>
                <tbody>
                <tr>
                    <td  width="100px" align="center" padding="2px" >Employee ID:</td>
                        <td width="100px" padding="1px">
                            <input style={{width:100}}
                                autoFocus="autofocus"
                                name="EmpID"
		        	            placeholder="Employee Id"
                                onChange={this.handleInputChange}
                                onFocus={ this.handleFocus}
                            />
                        </td>
                        <td  align="left" paddingtop="15px" height="40px" width="50px">
                            <button onClick={this.handleSubmit} className="btn btn-secondary active">Submit</button>
                        </td>
                </tr>
                <tr>
                <td  width="100px" ></td>
                        <td colSpan="2" style={{width:"100px",paddingTop:"0px",fontSize:"10pt",align:"left"}}>
                            <span className={this.state.errorcss}>{this.state.errortext}</span>
                        </td>
                </tr>
                </tbody>
                </table>

{/*}        <div width="100%" align="center" style={{display:isForm}} >  */}

                <div className="inner-profile">
                    <div style={{ width:"700px", left:"50%", margin:"0 auto"}} id="DReport" name="DReport"  ref={ref}>
                        <div  width="100%" align="center"  >
{/*}                            <h3>{config.gvr.ErrMsgs.Comp_Name}</h3>*/}
                            <h5>Leave Balances & Details</h5>
                            <br></br>
                            <span style={{float:"left"}}>
                            <table>
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td style={{width:"100px",border:"none"}}>Name:</td>
                                        <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Name']}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"100px",border:"none"}}>Designation:</td>
                                        <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Designation']}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"100px",border:"none"}}>Location:</td>
                                        <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Location']}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </span>
                            {/*<h6>{Moment(this.state.fromDate).format("DD/MM/YYYY")} - {Moment(this.state.toDate).format("DD/MM/YYYY")}</h6>*/}

                                    <table width="100%" margin="auto">
                                        <thead>
                                            <tr className="tr">
                                                <th className="th" scope="col"></th>
                                                <th className="th" scope="col">ANNUAL</th>
                                                <th className="th" scope="col">CASUAL</th>
                                                <th className="th" scope="col">SICK</th>
                                                <th className="th" scope="col">TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td className="tddesc" >Balance B/F</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFCasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFSick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["BFSick"])+Number(this.state.leavedata["BFCasual"])+Number(this.state.leavedata["BFAnnual"]))}</td>
                                        </tr>
                                        <tr >
                                            <td className="tddesc" >This year</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Annual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Casual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Sick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["Sick"])+Number(this.state.leavedata["Casual"])+Number(this.state.leavedata["Annual"]))}</td>
                                        </tr>
                                        <tr >

                                            <td className="tdhead" ><b>Balance</b></td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BAnnual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BCasual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BSick"])}</td>
                                            <td className="tdambhead" >{this.cur(Number(this.state.leavedata["BSick"])+Number(this.state.leavedata["BCasual"])+Number(this.state.leavedata["BAnnual"]))}</td>
                                        </tr>

                                        <tr >
                                            <td className="tddesc" >Leave Encashed</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["EAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["ECasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["ESick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["ESick"])+Number(this.state.leavedata["ECasual"])+Number(this.state.leavedata["EAnnual"]))}</td>
                                        </tr>
                                        <tr >
                                            <td className="tddesc" >Leaves</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LCasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LSick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["LSick"])+Number(this.state.leavedata["LCasual"])+Number(this.state.leavedata["LAnnual"]))}</td>
                                        </tr>

                                        <tr >
                                            <td className="tdhead" ><b>Balance C/F</b> </td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TAnnual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TCasual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TSick"])}</td>
                                            <td className="tdambhead" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]))}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                    <br></br>
                                    <div>
                                    <h5>Leave Detail</h5>
                                    <table width="100%" align="center">
                                        <thead >
                                            <tr className="tr">
                                                <th className="th" colSpan="3" scope="col">Leave Period</th>
                                                <th className="th" scope="col">Annual</th>
                                                <th className="th" scope="col">Casual</th>
                                                <th className="th" scope="col">Sick</th>
                                                <th className="th" scope="col">LWP</th>
                                                <th className="th" scope="col">Comp.</th>
{/*}                                                <th className="th" scope="col">Total</th>*/}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            
                                            {items.map((result ,i) => {
                                                
                                            return (
                                                <tr className="trc" key={i}>
                                                    <td className="tdamcenter-1" colSpan="3" >{Moment(result.LEAVE_FROM).format("DD/MM/YYYY")} - {Moment(result.LEAVE_TO).format("DD/MM/YYYY")}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LANNUAL)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LCASUAL)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LSICK)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LWP)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.Compensatory)}</td>
{/*}                                                    <td className="tdamcenter" >{this.cur(Number(result.LANNUAL)+Number(result.LCASUAL)+Number(result.LSICK)+Number(result.LWP)+Number(result.Compensatory))}</td>*/}
                                                </tr>
                                            )})
                                            }                                     
                                        </tbody>
                                    </table>
                                    <br></br>
                                  </div>
                                </div>
                            </div>
                 </div>
{/*}              </div>*/}
              <br></br><br></br>
          </div>
        );
    }
    else
    { return(null);}
  }
}